export default "__VITE_ASSET__GhajpY8z__"